export function FlameMark({ className = "h-8 w-8" }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="flame_grad" x1="7" y1="2" x2="35" y2="35" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EF4444" />
          <stop offset="0.5" stopColor="#FF9900" />
          <stop offset="1" stopColor="#F59E0B" />
        </linearGradient>
      </defs>
      <path
        d="M20 2C20 2 24 10 24 14C24 16.2 23.1 18.2 21.6 19.6C20.1 21 18 21.8 15.8 21.4C18 24.6 21.8 26.6 26 26C30.2 25.4 33.6 22.3 34.6 18.2C35.6 23.8 33.2 29.5 28.5 32.5C23.8 35.5 17.6 35.3 13.1 32C10.5 30.1 8.6 27.3 7.7 24.1C6.8 20.9 7.1 17.5 8.5 14.5C9.9 11.5 12.3 9.1 15.3 7.7C18.3 6.3 20 2 20 2Z"
        fill="url(#flame_grad)"
      />
      <circle cx="20" cy="34" r="2" fill="#F59E0B" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        if (window.__lenis) window.__lenis.scrollTo(0);
        else window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      data-testid="logo-home-link"
      className="flex items-center gap-2.5 group"
      aria-label="Utsav Crackers home"
    >
      <span className="group-hover:scale-110 transition-transform duration-300">
        <FlameMark className="h-8 w-8" />
      </span>
      {!compact && (
        <span className="leading-none">
          <span className="block font-display font-bold tracking-[0.18em] text-starlight text-lg">
            UTSAV
          </span>
          <span className="block font-mono text-[10px] tracking-[0.42em] text-ember mt-0.5">
            CRACKERS
          </span>
        </span>
      )}
    </a>
  );
}
